export const TEMPLATE_GROUPS = {
    COMPRA: 'Compra',
    VENDA: 'Venda',
    INDICADORES: 'Indicadores'
};

function findLastOrderKey(symbol, indexes) {
    const entry = indexes.find(ix =>
        ix.symbol === symbol && ix.variable && ix.variable.startsWith('LAST_ORDER_')
    );
    return entry ? `${symbol}:${entry.variable}` : null;
}

export function getFixedTemplates(symbol, indexes) {
    const lastOrderKey = findLastOrderKey(symbol, indexes);
    const aiSignalKey = `${symbol}:AI_SIGNAL`;

    const templates = [];

    if (lastOrderKey) {
        templates.push({
            group: TEMPLATE_GROUPS.COMPRA,
            name: 'Sem posição aberta',
            conditions: `(!MEMORY['${lastOrderKey}'] || MEMORY['${lastOrderKey}'].side == 'SELL')`,
            indexes: lastOrderKey
        });
    }

    templates.push({
        group: TEMPLATE_GROUPS.COMPRA,
        name: 'IA recomenda comprar',
        conditions: `MEMORY['${aiSignalKey}'].signal == 'BUY'`,
        indexes: aiSignalKey
    });

    if (lastOrderKey) {
        templates.push({
            group: TEMPLATE_GROUPS.VENDA,
            name: 'Com posição aberta',
            conditions: `MEMORY['${lastOrderKey}'].side == 'BUY'`,
            indexes: lastOrderKey
        });
    }

    templates.push({
        group: TEMPLATE_GROUPS.VENDA,
        name: 'IA recomenda vender',
        conditions: `MEMORY['${aiSignalKey}'].signal == 'SELL'`,
        indexes: aiSignalKey
    });

    templates.push({
        group: TEMPLATE_GROUPS.INDICADORES,
        name: 'RSI sobrevendido (< 30)',
        conditions: null,
        indexes: null,
        placeholder: 'RSI_{INTERVAL}.current < 30'
    });

    templates.push({
        group: TEMPLATE_GROUPS.INDICADORES,
        name: 'RSI sobrecomprado (> 70)',
        conditions: null,
        indexes: null,
        placeholder: 'RSI_{INTERVAL}.current > 70'
    });

    templates.push({
        group: TEMPLATE_GROUPS.INDICADORES,
        name: 'EMA cruzamento de alta',
        conditions: null,
        indexes: null,
        placeholder: 'EMA_{FAST}.current > EMA_{SLOW}.current'
    });

    templates.push({
        group: TEMPLATE_GROUPS.INDICADORES,
        name: 'EMA cruzamento de baixa',
        conditions: null,
        indexes: null,
        placeholder: 'EMA_{FAST}.current < EMA_{SLOW}.current'
    });

    return templates;
}

export function buildConditionFromIndex(symbol, indexEval, op, value) {
    return `${indexEval} ${op} ${value}`;
}

/**
 * Verifica se uma condition nova conflita com alguma existente.
 * Conflito: referência à mesma MEMORY key com eval diferente.
 */
export function findConflict(existingConditions, newConditions) {
    const extractKeys = str => {
        const matches = str.match(/MEMORY\['([^']+)'\]/g) || [];
        return matches.map(m => m.replace("MEMORY['", '').replace("']", ''));
    };

    const newKeys = extractKeys(newConditions);
    return existingConditions.find(c => {
        const existingKeys = extractKeys(c.eval);
        return newKeys.some(k => existingKeys.includes(k)) && c.eval !== newConditions;
    });
}
